// Upload 8-bit indexed Surfaces as GPU textures (R = palette index).

import { Texture, SCALE_MODES } from 'pixi.js';
import type { Surface } from '../surface';

const cache = new WeakMap<Surface, Texture>();

export function surfaceToIndexTexture(surf: Surface): Texture {
  let tex = cache.get(surf);
  if (tex) return tex;

  const w = surf.w;
  const h = surf.h;
  const rgba = new Uint8Array(w * h * 4);
  const pix = surf.pix;
  const alpha = surf.alpha;
  const ck = surf.colorKey;

  for (let i = 0; i < w * h; i++) {
    const idx = pix[i];
    const p = i * 4;
    rgba[p] = idx;
    rgba[p + 1] = 0;
    rgba[p + 2] = 0;
    let a = 255;
    if (alpha) a = alpha[i];
    else if (ck >= 0 && idx === ck) a = 0;
    rgba[p + 3] = a;
  }

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d')!;
  const img = ctx.createImageData(w, h);
  img.data.set(rgba);
  ctx.putImageData(img, 0, 0);

  tex = Texture.from(canvas);
  tex.source.scaleMode = SCALE_MODES.NEAREST ?? 'nearest';
  cache.set(surf, tex);
  return tex;
}

export function invalidateSurfaceTexture(surf: Surface): void {
  const tex = cache.get(surf);
  if (tex) {
    tex.destroy(true);
    cache.delete(surf);
  }
}
